import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import cn from "classnames";

const RotateComponent = forwardRef(
  (
    {
      from = -90,
      to = 90,
      value = 0,
      step = 1,
      precision = 0.1,
      onChange,
      onBlur,
      className = "",
      valueBarClassName = "",
    },
    ref
  ) => {
    const [localValue, setLocalValue] = useState(value);
    const liveValueRef = useRef(value);
    const draggingRef = useRef(false);

    useEffect(() => {
      if (!draggingRef.current) {
        setLocalValue(value);
        liveValueRef.current = value;
      }
    }, [value]);

    // expose refresh (used by wrapper)
    useImperativeHandle(ref, () => ({
      refresh: () => {},
    }));

    const emitDelta = (nextRaw) => {
      const next = Math.min(to, Math.max(from, Number(nextRaw)));
      const roundedNext = Math.round(next / precision) * precision;
      const delta = roundedNext - liveValueRef.current;

      if (Math.abs(delta) >= precision / 2 && onChange) {
        liveValueRef.current = roundedNext;
        onChange(delta);
      }
    };

    const onSliderChange = (event) => {
      const next = Number(event.target.value);
      setLocalValue(next);
      emitDelta(next);
    };

    const onStartInteraction = () => {
      draggingRef.current = true;
      document.body.classList.add("dragging");
    };

    const onEndInteraction = () => {
      draggingRef.current = false;
      document.body.classList.remove("dragging");
      if (onBlur) onBlur();
    };

    useEffect(() => {
      return () => {
        document.body.classList.remove("dragging");
      };
    }, []);

    return (
      <div className={cn("rmc-rotate-component", className)}>
        <div className="rmc-rotate-component__slider-wrap">
          <input
            type="range"
            className="rmc-rotate-component__slider"
            min={from}
            max={to}
            step={precision}
            value={localValue}
            onChange={onSliderChange}
            onMouseDown={onStartInteraction}
            onMouseUp={onEndInteraction}
            onTouchStart={onStartInteraction}
            onTouchEnd={onEndInteraction}
          />
          <div className={cn("rmc-rotate-component__value-number", valueBarClassName)}>
            {Number(localValue).toFixed(1)}°
          </div>
        </div>
      </div>
    );
  }
);

export default RotateComponent;